import { useEffect, useRef, useState } from 'react';
// contexts
import { useModalYoutubeContext } from 'context';
// components
import { Popover, Whisper } from 'rsuite';
// styles
import styles from './WavePulse.module.css';

const WavePulse = () => {
    const { setOpenModalYoutube } = useModalYoutubeContext();
    const [isActive, setIsActive] = useState<boolean>(false);
    const triggerRef = useRef(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleClose = (): void => {
        setIsActive(false);
        triggerRef.current?.close();
    };

    const handleOpen = (): void => {
        triggerRef.current?.open();
    };

    const handleOpenModal = () => {
        handleClose();
        setOpenModalYoutube(true);
    };

    useEffect(() => {
        const handleStorageChange = () => {
            const value = localStorage.getItem('firstShowModalYoutube');
            if (value === 'true') {
                setIsActive(true);
                handleOpen();
            }
        };

        window.addEventListener('firstShowModalYoutubeSet', handleStorageChange);

        return () => {
            window.removeEventListener('firstShowModalYoutubeSet', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [triggerRef]);

    return (
        <div className={styles['pulse-container']} ref={containerRef}>
            <div className={styles['icon']} onMouseEnter={handleOpen} onMouseLeave={() => !isActive && handleClose()}>
                <Whisper
                    placement="bottomStart"
                    speaker={
                        <Popover
                            className={`${styles['popover']} ${styles['fade-in']}`}
                            title={
                                <div>
                                    <p className={styles['title-popover']}>
                                        Vuelve a ver cómo conectar tus distribuidores
                                    </p>
                                </div>
                            }
                        >
                            <p>Aprende a conectarlos en un paso y comienza a comparar de manera inteligente.</p>
                        </Popover>
                    }
                    ref={triggerRef}
                    trigger="none"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="18"
                        viewBox="0 0 24 18"
                        fill="none"
                        onClick={handleOpenModal}
                        className={styles['svg']}
                    >
                        <path
                            d="M22.5396 3.68953C22.4208 3.21494 22.1789 2.7801 21.8382 2.42894C21.4976 2.07777 21.0703 1.82272 20.5996 1.68953C18.8796 1.26953 11.9996 1.26953 11.9996 1.26953C11.9996 1.26953 5.1196 1.26953 3.3996 1.72953C2.92884 1.86272 2.50157 2.11777 2.16094 2.46894C1.82031 2.8201 1.57838 3.25494 1.4596 3.72953C1.14481 5.47509 0.990831 7.24584 0.999595 9.01953C0.988374 10.8066 1.14236 12.5908 1.4596 14.3495C1.59055 14.8094 1.8379 15.2277 2.17774 15.564C2.51758 15.9003 2.93842 16.1433 3.3996 16.2695C5.1196 16.7295 11.9996 16.7295 11.9996 16.7295C11.9996 16.7295 18.8796 16.7295 20.5996 16.2695C21.0703 16.1363 21.4976 15.8813 21.8382 15.5301C22.1789 15.179 22.4208 14.7441 22.5396 14.2695C22.852 12.5371 23.0059 10.7799 22.9996 9.01953C23.0108 7.23249 22.8568 5.44823 22.5396 3.68953Z"
                            fill="white"
                            stroke="#0171E6"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M9.75 12.29L15.5 9.02L9.75 5.75V12.29Z"
                            fill="#0171E6"
                            stroke="#0171E6"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </Whisper>
            </div>

            <span className={`${styles.wave} ${styles.wave1} ${isActive ? styles.waveActive : ''}`} />
            <span className={`${styles.wave} ${styles.wave2} ${isActive ? styles.waveActive : ''}`} />
            <span className={`${styles.wave} ${styles.wave3} ${isActive ? styles.waveActive : ''}`} />
        </div>
    );
};

export default WavePulse;
